import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaSave, FaTimes } from "react-icons/fa";

const EditProfileModal = ({
  show,
  onHide,
  onSave,
  label,
  value,
  onChange,
  validateInput, // Pass validation function if needed per field
  field // Pass field name to determine input type etc.
}) => {

  const handleSaveClick = () => {
    onSave(); // Call the save handler passed from parent
  };

  const handleChange = (e) => {
    // Apply validation if provided, otherwise just update
    const newValue = validateInput ? validateInput(e.target.value, field) : e.target.value;
    onChange(newValue);
  };

  const capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1);
  const inputType = field === 'phone' ? 'tel' : 'text'; // Example: use 'tel' for phone

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit {capitalizedLabel}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={(e) => { e.preventDefault(); handleSaveClick(); }}> {/* Allow submitting with Enter key */}
          <Form.Group controlId={`formEdit${capitalizedLabel}`}>
            <Form.Label>{capitalizedLabel}</Form.Label>
            <Form.Control
              type={inputType}
              value={value}
              onChange={handleChange}
              placeholder={`Enter your ${label}`}
              autoFocus // Focus the input field when modal opens
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}> {/* Changed variant and ensured it's first */}
          <FaTimes className="me-1" /> Cancel
        </Button>
        <Button variant="primary" onClick={handleSaveClick}>
          <FaSave className="me-1" /> Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditProfileModal;
